import { getCurrentUserToken } from "modules/users";

export const reduxQueryDefaultOptions = (): {
  headers: { authorization: string };
} => ({
  headers: {
    authorization: `Bearer ${getCurrentUserToken()}`,
  },
});
